import type { SubscriptionInfo } from "model/Company";

export const FREE_SUBSCRIPTION_BACKEND_NAME = "Starter";
export const FREE_SUBSCRIPTION_DISPLAY_NAME = "Free";

export function isFreeSubscriptionName(
  membershipDisplayName: string | null | undefined,
): boolean {
  return membershipDisplayName === FREE_SUBSCRIPTION_BACKEND_NAME;
}

export function isFreeSubscription(
  subscription: SubscriptionInfo | null | undefined,
): boolean {
  return isFreeSubscriptionName(subscription?.membershipDisplayName);
}

interface SubscriptionLoadState {
  readonly companyId: number | null | undefined;
  readonly isLoading: boolean;
  readonly subscription: SubscriptionInfo | null;
}

export function isSubscriptionLoadedForCompany({
  companyId,
  isLoading,
  subscription,
}: SubscriptionLoadState): boolean {
  return (
    companyId != null &&
    !isLoading &&
    subscription != null &&
    subscription.companyId === companyId &&
    typeof subscription.membershipDisplayName === "string" &&
    subscription.membershipDisplayName.trim().length > 0
  );
}

export function getSubscriptionDisplayName(
  membershipDisplayName: string,
): string {
  return isFreeSubscriptionName(membershipDisplayName)
    ? FREE_SUBSCRIPTION_DISPLAY_NAME
    : membershipDisplayName;
}
